// extracted by mini-css-extract-plugin
export var container = "_s1-0";
export var dotAnimation = "_s1-2";
export var dotsLoading = "_s1-1";